
import api, { ResourceBalance, ResourceSummary } from './index'

export const getSummary = (url: any) => {
	return api.get<void, ResourceSummary>(url)
}

export const getBalance = (url: any) => {
	return api.get<void, ResourceBalance>(url)
}